export var DialogViewUtil;
(function (DialogViewUtil) {
    let FooterType;
    (function (FooterType) {
        FooterType[FooterType["None"] = 0] = "None";
        FooterType[FooterType["OkButton"] = 1] = "OkButton";
        FooterType[FooterType["PositiveNegativeButton"] = 2] = "PositiveNegativeButton";
    })(FooterType = DialogViewUtil.FooterType || (DialogViewUtil.FooterType = {}));
})(DialogViewUtil || (DialogViewUtil = {}));
